/* eslint-disable  @typescript-eslint/no-explicit-any */
import { produce } from "immer";
import { DISPATCHES } from "../../InterfacesTypes/enums";
import type {
  IOptionType,
  ISearchResult,
  IKeyWords,
  IWebSites,
} from "../../InterfacesTypes/interfaces";

interface IState {
  searchInput: string;
  searchResult: ISearchResult[];
  KeyWords: IKeyWords[];
  searchResultIndexCount: number;
  WebSites: IWebSites[];
  matchingKeyWords: string;
  matchingKeyWordsArray: string[];
  userSelectedInputKeyWord: IOptionType;
  webSiteSearchResults: IWebSites[];
}

const initialDefaultState: IState = {
  searchInput: "",
  searchResult: [],
  KeyWords: [],
  searchResultIndexCount: 0,
  WebSites: [],
  matchingKeyWords: "",
  matchingKeyWordsArray: [],
  userSelectedInputKeyWord: { label: "", value: "" } as IOptionType,
  webSiteSearchResults: [],
};

export interface IDefaultAction {
  type: DISPATCHES | string;
  payload?: any;
}

export const State = (
  state: IState = initialDefaultState,
  action: IDefaultAction
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case DISPATCHES.INCREMENT:
        draft.searchResultIndexCount = action.payload;
        break;
      case DISPATCHES.DECREMENT:
        draft.searchResultIndexCount = action.payload;
        break;
      case DISPATCHES.SEARCH_INPUT_SET_ACTION:
        draft.searchInput = action.payload;
        break;
      case DISPATCHES.SEARCH_RESULT_DISPATCH_ACTION:
        draft.searchResult = action.payload;
        break;
      case DISPATCHES.SEARCH_INPUT_RESET_ACTION:
        // Resets to initial state values so no payload is required for reset action
        draft.searchInput = initialDefaultState.searchInput;
        draft.searchResult = initialDefaultState.searchResult;
        draft.webSiteSearchResults = initialDefaultState.webSiteSearchResults;
        draft.searchResultIndexCount =
          initialDefaultState.searchResultIndexCount;
        draft.matchingKeyWordsArray = initialDefaultState.matchingKeyWordsArray;
        break;
      case DISPATCHES.SET_SP_KEYWORDS:
        draft.KeyWords = action.payload;
        break;
      case DISPATCHES.SET_SP_WEBSITES:
        draft.WebSites = action.payload;
        break;
      case DISPATCHES.SET_MATCHING_KEYWORDS_STRINGS:
        draft.matchingKeyWords = action.payload;
        break;
      case DISPATCHES.SET_MATCHING_INDIVIDUAL_KEYWORDS_ARRAY:
        draft.matchingKeyWordsArray = action.payload;
        break;
      case DISPATCHES.SET_USER_SELECTED_INPUT_KEYWORD:
        draft.userSelectedInputKeyWord = action.payload;
        // resets the searchResultIndexCount in case the user switched between results
        // and makes a new search without hitting the x first.
        draft.searchResultIndexCount =
          initialDefaultState.searchResultIndexCount;
        break;
      case DISPATCHES.SET_MATCHING_WEBSITES_ARRAY:
        draft.webSiteSearchResults = action.payload;
        break;
    }
  });
};
